import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	CorporatesListState,
	CorporatesState,
	fetchCorporates,
	getCorporatesPaginated,
	updateCorporate,
} from "../actions/corporates"

const initialState: CorporatesListState = {
	loading: false,
	loadingFetch: false,
	error: undefined,
	errorFetch: undefined,
	list: [],
	selected: undefined,
}

const corporatePaginatedSlice = createSlice({
	name: "corporatesPaginated",
	initialState: initialState,
	reducers: {
		clearError: (state: CorporatesListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: CorporatesListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.list = []
			state.selected = undefined
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getCorporatesPaginated.pending, (state: CorporatesListState) => {
				state.loading = true
				state.error = undefined
			})
			.addCase(
				getCorporatesPaginated.fulfilled,
				(
					state: CorporatesListState,
					action: PayloadAction<CorporatesState[]>
				) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload
				}
			)
			.addCase(
				getCorporatesPaginated.rejected,
				(state: CorporatesListState, action) => {
					state.loading = false
					state.error = action?.payload.message
				}
			)
			.addCase(fetchCorporates.pending, (state: CorporatesListState) => {
				state.loadingFetch = true
				state.errorFetch = undefined
			})
			.addCase(
				fetchCorporates.fulfilled,
				(
					state: CorporatesListState,
					action: PayloadAction<CorporatesState[]>
				) => {
					state.loadingFetch = false
					state.errorFetch = undefined
					state.list = {
						nextUrl: action?.payload.nextUrl,
						page: {
							...action?.payload.page,
							content: [
								...state.list.page.content,
								...action?.payload.page.content,
							],
						},
					}
				}
			)
			.addCase(
				fetchCorporates.rejected,
				(state: CorporatesListState, action) => {
					state.loadingFetch = false
					state.errorFetch = action?.payload.message
				}
			)
			.addCase(
				updateCorporate.fulfilled,
				(
					state: CorporatesListState,
					action: PayloadAction<CorporatesState>
				) => {
					state.list = {
						...state.list,
						page: {
							...state.list?.page,
							content: state.list.page.content.map(
								(corporate: CorporatesState) =>
									corporate.corporateSenderId ===
									action?.payload?.data?.corporateSenderId
										? action?.payload?.data
										: corporate
							),
						},
					}
				}
			)
	},
})

export const { clearError, resetDefault } = corporatePaginatedSlice.actions

export default corporatePaginatedSlice.reducer
